import { CalendarDays, CreditCard, PackageCheck, ShoppingBag } from 'lucide-react'
import {
  formatPrice,
  orderStatusLabels,
  paymentMethodLabels,
  paymentStatusLabels,
  type ShopOrder,
} from '../types/Shop'

const OrderList = ({ orders }: { orders: ShopOrder[] }) => {
  if (orders.length === 0) {
    return (
      <div className="empty-state">
        <ShoppingBag className="mx-auto mb-4 h-10 w-10 text-emerald-600" />
        <h2>Aucune commande pour le moment</h2>
        <p className="mt-2 text-gray-600">Vos prochaines commandes apparaîtront ici.</p>
      </div>
    )
  }

  return (
    <div className="order-list">
      {orders.map((order) => (
        <article className="order-card" key={order.id}>
          <header className="order-card-header">
            <div>
              <p className="eyebrow !mb-1">Commande</p>
              <h2>{order.orderNumber}</h2>
            </div>
            <span className={`shop-status shop-status-${order.status.toLowerCase()}`}>
              {orderStatusLabels[order.status]}
            </span>
          </header>

          <div className="order-meta-grid">
            <span><CalendarDays aria-hidden="true" /> {new Date(order.createdAt).toLocaleDateString('fr-FR')}</span>
            <span><CreditCard aria-hidden="true" /> {order.payment ? paymentMethodLabels[order.payment.method] : 'Paiement inconnu'}</span>
            <span><PackageCheck aria-hidden="true" /> {order.payment ? paymentStatusLabels[order.payment.status] : 'À payer'}</span>
          </div>

          <div className="order-lines">
            {order.items.map((item) => (
              <div className="order-line" key={item.id}>
                <img src={item.imageUrl} alt="" />
                <div>
                  <strong>{item.productName}</strong>
                  <small>Taille {item.variantLabel} · Quantité {item.quantity}</small>
                  {item.memberQuantity > 0 && <small className="member-price-note">{item.memberQuantity} unité au tarif adhérent</small>}
                </div>
                <strong>{formatPrice(item.lineTotalCents)}</strong>
              </div>
            ))}
          </div>

          <footer className="order-card-footer">
            <span>Retrait au club</span>
            <strong>{formatPrice(order.totalCents)}</strong>
          </footer>
        </article>
      ))}
    </div>
  )
}

export default OrderList
